<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
    />

    <vs-table
      noDataText="Nenhuma Corretora Encontrada"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :max-items="itemsPerPage"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="activeOrInactive(false)"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="activeOrInactive(true)"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="regionais.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar nova Corretora</span
            >
          </div>
        </div>

        <div class="flex">
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">
                {{ getPaginationText }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-input
            icon="search"
            placeholder="CNPJ/CPF ou Razão Social"
            v-model="brokerSearched"
          />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="razaoSocial">Razão Social</vs-th>
        <vs-th sort-key="cpfCnpj">CNPJ/CPF</vs-th>
        <vs-th sort-key="state">Estado</vs-th>
        <vs-th sort-key="city">Cidade</vs-th>
        <vs-th sort-key="deletedAt">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.corporateName }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.cpfCnpj }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.state }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.city }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.isActive)"
                class="product-order-status"
              >
                {{ getStatusString(tr.isActive) }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <p class="product-price">
                <vs-button
                  radius
                  v-tooltip="'Detalhes'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="d-inline"
                  @click="opemModal(tr.id)"
                ></vs-button>
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openSideBar(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
                <vs-button
                  radius
                  v-tooltip="'Histórico de Alterações'"
                  color="#88abc2"
                  icon-pack="feather"
                  icon="icon-archive"
                  class="d-inline"
                  @click="abrirModalHistoricoUsuarios(tr)"
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="mt-6">
      <vs-pagination
        :total="parseInt(count / itemsPerPage) + 1"
        v-model="currentPage"
      ></vs-pagination>
    </div>

    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados da ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <ModalHistoricoAlteracoes
      :popupActive="popupAlteracoesActive"
      :tipo="tipoHistorico"
      :nome="nomeHistorico"
      :dadosConsulta="dadosConsultaHistorico"
      @close="fecharModalHistorico"
    ></ModalHistoricoAlteracoes>
  </div>
</template>

<script>
import AddNewDataSidebar from './../Includes/SideBar';
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';
import ModalHistoricoAlteracoes from '../modais/ModalHistoricoAlteracoes.vue';

import service from '../../services';
import notify from '../../utils/notify';
import functions from '../../utils/functions';

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
    ModalHistoricoAlteracoes,
  },
  props: ['subjectPermission'],
  data() {
    return {
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: 'BrokerBlocklist',
      formSideBar: 'BrokerBlocklist',
      entidade: 'Corretora na Blocklist',
      titleSideBar: 'Adicionar Corretora',
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      currentPage: 1,
      count: 0,
      addNewDataSidebar: false,
      corretoras: [],
      brokerSearched: null,
      debounce: functions.debounce(this.buscaDados, 1000),
      dadosConsultaHistorico: [],
      tipoHistorico: 'Blocklist de Corretoras',
      nomeHistorico: '',
      popupAlteracoesActive: false,
    };
  },
  computed: {
    getPaginationText() {
      const start =
        this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
      const end =
        this.count - this.currentPage * this.itemsPerPage > 0
          ? this.currentPage * this.itemsPerPage
          : this.count;
      return `${start} - ${end} de ${this.count}`;
    },
  },
  watch: {
    currentPage() {
      this.buscaDados();
    },
    itemsPerPage() {
      this.buscaDados();
    },
    brokerSearched: {
      handler: function () {
        this.debounce();
      },
    },
  },
  methods: {
    imprimir() {
      window.print();
    },
    activeOrInactive(isActive) {
      if (this.selected.length > 0) {
        this.$vs.loading();
        let ids = [];
        this.selected.forEach((element) => {
          ids.push(element.id);
        });
        const action = isActive ? 'reativado' : 'inativado';
        service
          .post(this.controllerGeral, 'InativarReativar', {
            ids: ids,
            isActive,
          })
          .then(() => {
            notify.notifySuccess(this.$vs, `Registro ${action}(s) com sucesso`);
            this.buscaDados();
          })
          .catch((e) => notify.notifyFail(this.$vs, e))
          .finally(() => this.$vs.loading.close());
      } else {
        notify.notifyFail(this.$vs, 'Selecione pelo menos um registro');
      }
    },
    async buscaDados() {
      try {
        let url = `list-pagination/idEmpresa=${this.idEmpresa}`;

        if (this.currentPage && this.itemsPerPage) {
          url = url + `?page=${this.currentPage}&item=${this.itemsPerPage}`;
        }

        if (this.brokerSearched) {
          url = url + `&searched=${this.brokerSearched}`;
        }

        this.$vs.loading();

        const res = await service.getAll(this.controllerGeral, {}, url);

        this.itens = res.data.rows;
        this.count = res.data.count;

        this.colunas = {};
        if (this.itens[0])
          Object.keys(this.itens[0]).forEach((element) => {
            if (
              element != 'createdAt' &&
              element != 'updatedAt' &&
              element != 'deletedAt' &&
              element.indexOf('id') != 0
            ) {
              this.colunas[element] = element;
            }
          });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    openSideBar(dados) {
      dados.id == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados da ${this.entidade}`);
      this.dadosSideBar = { ...dados, corretoras: this.corretoras };
      this.addNewDataSidebar = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;

      const colunaMap = {
        isActive: 'Está ativo?',
        cpfCnpj: 'CNPJ/CPF',
        corporateName: 'Razão Social',
        state: 'Estado',
        city: 'Cidade',
        observation: 'Observação',
        partnerCpf1: 'CPF do Sócio 1',
        partnerCpf2: 'CPF do Sócio 2',
        partnerCpf3: 'CPF do Sócio 3',
        partnerCpf4: 'CPF do Sócio 4',
        partnerCpf5: 'CPF do Sócio 5',
        partnerCpf6: 'CPF do Sócio 6',
        partnerCpf7: 'CPF do Sócio 7',
        partnerCpf8: 'CPF do Sócio 8',
      };

      let item = this.itens.find((x) => x.id == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        ) {
          const colunaRenomeada = colunaMap[element] || element;
          let valor = item[element];

          if (element === 'isActive') {
            valor = item[element] === 1;
          }

          this.modalSelecionado.push({
            coluna: colunaRenomeada,
            [colunaRenomeada]: valor,
          });
        }
      });
    },
    concluido() {
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data) return 'Ativo';
      return 'Inativo';
    },
    abrirModalHistoricoUsuarios(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'brokerBlocklist',
          id: item.id,
        },
      ];
      this.nomeHistorico = item.nome;
      this.popupAlteracoesActive = true;
    },
    fecharModalHistorico() {
      this.popupAlteracoesActive = false;
    },
  },
  created() {
    this.buscaDados();
    functions.buscaDadosSelects(
      'brokerBlocklist',
      this.corretoras,
      'corporateName',
      'id',
      'idEmpresa/118',
    );
  },
};
</script>

<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }

      .vs-con-input-label,
      .vs-con-input {
        width: 250px;
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
